export default "__VITE_ASSET__0c78aa03__"